export default __webpack_public_path__ + "static/MBORNTOSHINEHAT-NEONPINK_600x600-53301f99b46d254bd62d9c3a5ccb6038.png";